export function init($name = '') {
    const arrows = $($name);

    if (!arrows.length) {
        return;
    }

    arrows.each(function () {
        const arrow = $(this);
        prepareArrow(arrow);

        $(window).resize(function() {
            prepareArrow(arrow);
        });
    });
}

function prepareArrow(arrow) {
    if (arrow.parent().outerHeight() <= $(window).height()) {
        arrow.removeAttr('style');
        return;
    }

    let top = $(window).width() > 1000 ? 'calc(100vh - 72px)' : 'calc(100vh - 42px)';

    arrow.css({
       top : top,
       bottom : 'auto'
    });
}
